import { render, staticRenderFns } from "./QAQCDialog.vue?vue&type=template&id=e70040b0"
import script from "./QAQCDialog.vue?vue&type=script&lang=ts"
export * from "./QAQCDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports